<!-- beaut-497. Outside <nz-table> on purpose: nz-table claims the markup inside
     it, and a stray <thead> anywhere beneath it gets stolen for its own header
     (learned on the duplicate-customers screen). -->
<!-- beaut-497. Outside <nz-table> on purpose: nz-table claims the markup
     inside it, and a stray <thead> anywhere beneath it gets stolen for its own
     header (learned on the duplicate-customers screen).

     Three controls, three questions: whose package it is, how far through it
     is, and what the sale is. They narrow independently — the operator asking
     "what did I sell this customer that is still unused" needs two of them at
     once. -->
<div class="pkg__filters">
  <nz-radio-group
    [ngModel]="giftFilter()"
    (ngModelChange)="setGiftFilter($event)"
    nzButtonStyle="solid"
    nzSize="small"
    data-test="gift-filter"
  >
    <label nz-radio-button nzValue="ALL" data-test="gift-filter-all">
      {{ 'servicePackages.filters.all' | translate }}
    </label>
    <label nz-radio-button nzValue="OWN" data-test="gift-filter-own">
      {{ 'servicePackages.filters.ownPurchases' | translate }}
    </label>
    <label nz-radio-button nzValue="RECEIVED" data-test="gift-filter-received">
      <span nz-icon nzType="gift"></span>
      {{ 'servicePackages.filters.receivedGifts' | translate }}
    </label>
    <label nz-radio-button nzValue="GIVEN" data-test="gift-filter-given">
      {{ 'servicePackages.filters.givenGifts' | translate }}
    </label>
  </nz-radio-group>

  <div class="pkg__selects">
  <nz-select
    class="pkg__select"
    nzSize="small"
    nzAllowClear
    [ngModel]="lifecycleFilter()"
    (ngModelChange)="setLifecycleFilter($event)"
    [nzPlaceHolder]="'servicePackages.purchases.lifecycle' | translate"
    data-test="lifecycle-filter"
  >
    @for (option of lifecycleOptions; track option.value) {
      <nz-option
        [nzValue]="option.value"
        [nzLabel]="option.label | translate"
      ></nz-option>
    }
  </nz-select>

  <nz-select
    class="pkg__select"
    nzSize="small"
    nzAllowClear
    [ngModel]="statusFilter()"
    (ngModelChange)="setStatusFilter($event)"
    [nzPlaceHolder]="'servicePackages.purchases.status' | translate"
    data-test="status-filter"
  >
    @for (option of statusOptions; track option.value) {
      <nz-option
        [nzValue]="option.value"
        [nzLabel]="option.label | translate"
      ></nz-option>
    }
  </nz-select>
  </div>
</div>

<nz-table
  [nzData]="purchases()"
  [nzLoading]="loading()"
  [nzTotal]="total()"
  [nzPageSize]="pageSize()"
  [nzPageIndex]="page()"
  [nzFrontPagination]="false"
  nzShowSizeChanger
  [nzPageSizeOptions]="[10, 20, 50]"
  (nzPageIndexChange)="onPageChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
  nzSize="small"
>
  <thead>
    <tr>
      <th>{{ 'servicePackages.purchases.package' | translate }}</th>
      <th>{{ 'servicePackages.purchases.status' | translate }}</th>
      <th>{{ 'servicePackages.purchases.lifecycle' | translate }}</th>
      <th>{{ 'servicePackages.purchases.usage' | translate }}</th>
      <th>{{ 'servicePackages.purchases.price' | translate }}</th>
      <th>{{ 'servicePackages.purchases.validUntil' | translate }}</th>
      <th nzWidth="80px">{{ 'servicePackages.columns.actions' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (purchase of purchases(); track purchase.id) {
      <tr>
        <!-- Prefer snapshot (displayName) over live-joined template name —
             see BE PR #169 for the why. -->
        <td>
          <div class="pkg__name">
            {{ purchase.displayName || purchase.package?.name || '—' }}
          </div>
          <!-- beaut-497. Badges sit UNDER the name, not beside it. Inline they
               stretched this column and pushed the numeric columns off to the
               right; the name is what the eye scans, the badges qualify it. -->
          @let direction = giftDirection(purchase);
          @if (purchase.isEdited || direction) {
            <div class="pkg__badges">
              @if (purchase.isEdited) {
                <span class="badge badge--edited">
                  {{ 'servicePackages.purchases.editedBadge' | translate }}
                </span>
              }
              @if (direction === 'received') {
                <span class="badge badge--gift" data-test="gift-received">
                  <span nz-icon nzType="gift"></span>
                  {{ 'servicePackages.purchases.giftFrom' | translate }}
                  {{ purchase.payer?.name }}
                </span>
              } @else if (direction === 'given') {
                <span class="badge badge--given" data-test="gift-given">
                  {{ 'servicePackages.purchases.giftTo' | translate }}
                  {{ purchase.customer?.name }}
                </span>
              }
            </div>
          }
        </td>
        <td>
          <nz-tag [nzColor]="getStatusColor(purchase.status)">
            {{ 'servicePackages.status.' + purchase.status | translate }}
          </nz-tag>
        </td>
        <td>
          <nz-tag [nzColor]="purchase | packageLifecycleColor">
            {{ purchase | packageLifecycle | translate }}
          </nz-tag>
        </td>
        <td>
          <div class="flex items-center gap-2">
            <nz-progress
              [nzPercent]="getUsagePercent(purchase)"
              [nzWidth]="36"
              nzType="circle"
              nzSize="small"
            ></nz-progress>
            <span class="text-xs text-gray-500">
              {{ purchase.usedServicesCount }}/{{ purchase.totalServicesCount }}
            </span>
          </div>
        </td>
        <td>{{ purchase.purchasePrice | number:'1.2-2' }} ₾</td>
        <td>{{ purchase.validUntil | date:'dd/MM/yyyy' }}</td>
        <td>
          <div class="flex gap-1">
            <button
              nz-button
              nzType="text"
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'servicePackages.buttons.details' | translate"
              (click)="viewDetails(purchase)"
            >
              <span nz-icon nzType="eye" nzTheme="outline"></span>
            </button>
            @if (purchase.status === 'ACTIVE' || purchase.status === 'USED') {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nz-tooltip
                [nzTooltipTitle]="'buttons.edit' | translate"
                [disabled]="editOpening()"
                (click)="openEditModal(purchase)"
              >
                <span nz-icon nzType="edit" nzTheme="outline"></span>
              </button>
            }
            <!-- #2908 §8 follow-up: a fully-consumed (USED) package is editable
                 but NOT cancellable — cancel stays gated to ACTIVE only. -->
            @if (purchase.status === 'ACTIVE') {
              <button
                nz-button
                nzType="text"
                nzSize="small"
                nzDanger
                nz-tooltip
                [nzTooltipTitle]="'servicePackages.buttons.cancel' | translate"
                (click)="cancelPurchase(purchase)"
              >
                <span nz-icon nzType="close-circle" nzTheme="outline"></span>
              </button>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
